import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-sport-voetbal',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconSportVoetbal {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M17 3.5C17 1.57 18.57 0 20.5 0S24 1.57 24 3.5 22.43 7 20.5 7 17 5.43 17 3.5m13.02 26.53a2.981 2.981 0 1 0 .002 5.962 2.981 2.981 0 0 0-.002-5.962m-8.37-13.65a3.438 3.438 0 0 0 2.92 1.61H29c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-4.45c0-.33-4.13-6.1-4.13-6.11-.71-.93-2.53-1.18-3.91-.74 0 0-5.94 2.41-6.9 2.81-.86.36-1.62 1.01-1.62 2.03v5c0 .55.45 1 1 1h.99a.99.99 0 0 0 1-1l-.03-4.08s2.46-.99 3.59-1.44l-1.23 5.47c-.24 1.07.12 2.19.95 2.91l5.73 5.02v9.12c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-9.15c0-.95-.42-1.85-1.15-2.47l-3.01-2.83 1.48-6.22 1.32 2.05Zm-10.68 9.61H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7.96c.6 0 1.14-.36 1.38-.91l1.38-4.14-2.44-2.12-1.3 4.16Z"/>
</svg>

    );
  }
}
